
// 字符串是否是数字
function isNumber (s) {
  return !isNaN(s) && Number.isInteger(parseFloat(s))
}

export {
  isNumber
}
